import { z } from 'zod';
import { addressSchema, ensNameSchema } from './common.js';
export const resolveEnsParamsSchema = z.object({
    name: ensNameSchema,
    blockHeight: z.number().int().nonnegative().optional(),
}).strict();
export const reverseEnsParamsSchema = z.object({
    address: addressSchema,
    blockHeight: z.number().int().nonnegative().optional(),
}).strict();
export const ensResolveDataSchema = z.object({
    name: ensNameSchema,
    address: addressSchema,
    avatar: z.string().min(1).optional(),
}).strict();
export const ensReverseDataSchema = z.object({
    address: addressSchema,
    name: z.union([ensNameSchema, z.null()]),
}).strict();
